import styled from 'styled-components';

export const StyledContainer = styled.div`
  .wrapper-add-schema {
    display: flex;
    justify-content: center;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
`;

export const StyledEditorWrapper = styled.div`
  display: grid;
  grid-template-column: auto auto auto auto;
  column-gap: 10px;
  .editor__labels {
    margin: 12px 0 6px 6px;
  }
  .editor__transformation-response {
    height: 438px;
  }
`;

export const StyledCardCustom = styled.div`
  margin-top: 10px;
`;
